'use strict';
var config = function($window,$log) {
  this.$window=$window;
  this.$log=$log;
  this.hosts={
    "localhost": {
      "serviceUrl":"http://localhost/outdoor/src/services/index.php"
    },
    "outdoor": {
      "serviceUrl":"https://outdoor.lapetitemerveille.be/services/index.php"
    },
    "adventure-valley": {
      "serviceUrl":"https://outdoor.lapetitemerveille.be/services/index.php"
    },
    "customwebapplications": {
      "serviceUrl":"http://customwebapplications.be/outdoor/services/index.php"
    }
  };
  this.hostname=null;
  this.langs=['en','nl','fr'];
};
config.prototype.get = function(key) {
  var result="";
  if(this.hostname===null) {
    this.hostname=this.$window.location.hostname;
    if(this.hostname.match(/^www\./)) {
      this.hostname=this.hostname.substr(4);
    }
    this.hostname=this.hostname.split(".")[0];
  }
  if(this.hostname in this.hosts) {
    result=this.hosts[this.hostname][key];
  } else {
    this.$log.log("ERROR: domain <"+this.hostname+"> is not configured");
  }
  return result;
};
angular.module("app").service("config",["$window","$log",config]);
